import create from 'zustand';
import { immer } from 'zustand/middleware/immer';

import type * as Zustand from 'zustand';

export type { Draft } from 'immer';

export type StateCreator<T> = Zustand.StateCreator<
  T,
  [['zustand/immer', never]]
>;

type WithImmer<T> = Zustand.StoreMutators<T, unknown>['zustand/immer'];
export type UseBoundStore<T> = Zustand.UseBoundStore<
  WithImmer<Zustand.StoreApi<T>>
>;

export const createStore = <T>(initializer: StateCreator<T>) => {
  return create(immer(initializer));
};
